export function buildInstrucoes(record, overrides = {}) {
  const tipoMulta = overrides.tipoMulta ?? record.tipoMulta
  const tipoJurosMora = overrides.tipoJurosMora ?? record.tipoJurosMora

  const hasKey = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key)

  const valorJurosMora = hasKey(overrides, 'valorJurosMora') ? overrides.valorJurosMora : record.valorJurosMora
  const percentualJurosMora = hasKey(overrides, 'percentualJurosMora')
    ? overrides.percentualJurosMora
    : record.percentualJurosMora
  const valorMulta = hasKey(overrides, 'valorMulta') ? overrides.valorMulta : record.valorMulta
  const percentualMulta = hasKey(overrides, 'percentualMulta') ? overrides.percentualMulta : record.percentualMulta

  const parsePositiveNumber = (value) => {
    if (value == null || value === '') return 0
    if (typeof value === 'number') return Number.isFinite(value) ? value : 0
    if (typeof value === 'string') {
      const normalized = value.replace(/R\$/g, '').replace(/%/g, '').replace(/\./g, '').replace(/,/g, '.').trim()
      const n = Number.parseFloat(normalized)
      return Number.isFinite(n) ? n : 0
    }
    return 0
  }

  const resolvePart = (kind, tipo, valorReais, valorPercentual) => {
    if (!tipo || !tipo.id) return null

    if (tipo.id === 3) return null

    if (tipo.id === 2) {
      if (parsePositiveNumber(valorPercentual) <= 0) return null
      const v = valorPercentual ?? ''
      return `${kind} ${v}%`
    }

    if (parsePositiveNumber(valorReais) <= 0) return null
    const v = valorReais ?? ''
    return `${kind} R$ ${v}`
  }

  const jurosPart = resolvePart('cobrar', tipoJurosMora, valorJurosMora, percentualJurosMora)
  const multaPart = resolvePart('multa de', tipoMulta, valorMulta, percentualMulta)

  if (!jurosPart && !multaPart) return ''

  if (jurosPart && multaPart) {
    const jurosSemCobrar = jurosPart.replace(/^cobrar\s+/, '')
    return `Após vencimento cobrar ${jurosSemCobrar} de juros ao mês e ${multaPart}.`
  }

  if (jurosPart) {
    const jurosSemCobrar = jurosPart.replace(/^cobrar\s+/, '')
    return `Após vencimento cobrar ${jurosSemCobrar} de juros ao mês.`
  }

  return `Após vencimento cobrar ${multaPart}.`
}

export function mergeInstrucoes(currentInstrucoes, novaInstrucaoPadrao) {
  const current = currentInstrucoes || ''

  const semPadrao = current.replace(/^\s*Após vencimento[^.]*\.(\s*)/i, '').replace(/^\s+/, '')

  if (!novaInstrucaoPadrao || String(novaInstrucaoPadrao).trim() === '') {
    return semPadrao
  }

  if (!semPadrao) {
    return novaInstrucaoPadrao
  }

  return `${novaInstrucaoPadrao} ${semPadrao}`
}
